import {
  Dialog, DialogActions, DialogContent, DialogTitle,
} from '@mui/material';
import { FC } from 'react';
import { useFormContext } from 'react-hook-form';

import CustomButton from 'components/CustomButton';
import PickupInformationForm from 'components/PickupInformationForm';

import { DeliveryMethod } from 'constants/enums';

interface PickUpModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
}

const PickUpModal: FC<PickUpModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const { watch, setValue } = useFormContext();

  const { delivery } = watch();

  const handleCancel = () => {
    setValue('delivery.pickupDate', null);
    setValue('delivery.pickupTime', null);
    onClose();
  };

  const handleSubmit = () => {
    onSubmit();
    onClose();
  };

  const handleOnValueChange = (value: any, name: string) => {
    setValue(name, value);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="pick-up-modal-update-order"
    >
      <DialogTitle>Pickup Details</DialogTitle>
      <DialogContent>
        <PickupInformationForm
          onValueChange={handleOnValueChange}
          delivery={{
            method: DeliveryMethod.PICKUP, // @TODO add method when API available
            pickupDate: delivery?.pickupDate ? new Date(delivery?.pickupDate) : null,
            pickupTime: delivery?.pickupTime ? new Date(delivery?.pickupTime) : null,
          }}
          fieldErrors={{}}
          orderDateRestrictions={null}
          isLoadingDateRestrictions={false}
        />

        <DialogActions>
          <CustomButton
            id="button-cancelPickupDate"
            variant="outlined"
            onClick={handleCancel}
          >
            Cancel
          </CustomButton>

          <CustomButton
            id="button-savePickupDate"
            variant="contained"
            onClick={handleSubmit}
          >
            Save
          </CustomButton>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default PickUpModal;
